module.exports = __webpack_public_path__ + "img/en-2.d27d9cc8.png";